import { render, staticRenderFns } from "./ListFoods.vue?vue&type=template&id=ad61beca&"
import script from "./ListFoods.vue?vue&type=script&lang=js&"
export * from "./ListFoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports